/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-06-30 11:14:14
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-12 10:21:26
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Input,
  notification,
  Radio,
  Row,
} from 'antd'
import { DataNode } from 'antd/lib/tree'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import {
  appointmentSettingDoctorsAsync,
  appointmentSettingDetailAsync,
  appointmentSettingAsync,
  setIsUpdate,
} from '../../../appointment/appointmentSelice'
import styles from '../../functionSettingTabs.module.css'
import { getSaveAiSettingsAsync, getSelectAiSettingsAsync } from './AISettingSlice'
import _ from 'lodash'
import { Settinglable } from '../../../../models/setting'
import { SaveAiSettingParams } from '../../../../services/AISetting'
import { AIChecks } from '../../../../models/AISetting'

export const AISettings = (props: {
  selectedTab: any
}): ReactElement => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const [complaintNumber, setComplaintNumber] = useState('0')

  const [buttonLoading, setButtonLoading] = useState(false)

  useEffect(() => {
    if (props?.selectedTab != '8') return
    getDetail()
  }, [props?.selectedTab])

  const getDetail = () => {
    dispatch(getSelectAiSettingsAsync()).then(unwrapResult).then((v: any) => {
      const sczszd = v?.filter((val: any) => val?.type == AIChecks.SCZSZS)?.[0]
      setComplaintNumber(Number(sczszd?.value) && Number(sczszd?.value) > 0 ? '1' : '0')
      form.setFieldsValue({
        mainComplaintWords:Number(sczszd?.value) && Number(sczszd?.value) > 0 ? sczszd?.value : 20,
       [AIChecks.SCZSZS]:Number(sczszd?.value) && Number(sczszd?.value) > 0 ? '1' : '0'
      })
    })
  }
  return (
    <Col className={styles.AISetting}>
      <Form
        form={form}
        onFinish={(values) => {
          const pattern = /^[0-9]*$/
          const t = _.chain(values)
            .omitBy((_, k) => pattern.test(k))
            .value() as any

          const f = _.chain(values)
            .pickBy((_, k) => pattern.test(k))
            .mapValues(
              (v, k: any) =>
              ({
                type: k,
                value: k == AIChecks.SCZSZS ? (v == 1 ? Number(values?.mainComplaintWords) : 0) : v?.toString(),
                businessTypes: null
              } as SaveAiSettingParams)
            )
            .values()
            .value()
          setButtonLoading(true)
          dispatch(getSaveAiSettingsAsync(f)).then(unwrapResult).then((v: any) => {
            notification.success({
              message: '操作成功',
            })
            getDetail()
          })
          .finally(() => {
            setButtonLoading(false)
          })
        }}
      >
        <div style={{ overflow: 'auto', height: 'calc(100% - 40px)' }}>
          <Row
            style={{
              fontSize: 16,
              fontWeight: 'bold',
              borderBottom: '1px dashed #BBBBBB',
              paddingBottom: '10px',
              width: '90%',
            }}
          >
            AI生成病历设置
          </Row>
          <div style={{ marginTop: '20px' }}>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item label='生成主诉字数' name={AIChecks.SCZSZS}>
                <Radio.Group value={complaintNumber}
                  onChange={(e) => {
                    setComplaintNumber(e.target.value)
                  }}>
                  <Radio value={'0'}>不限制</Radio>
                  <Radio value={'1'}>
                    <Row style={{ display: 'flex', alignItems: 'center' }}>
                      <span style={{ margin: '0 10px 0 0' }}>限制</span>
                      <Form.Item name='mainComplaintWords' label='' rules={[
                         {
                          required:complaintNumber == '1' ? true : false,
                          message: '请输入大于等于10的数字'
                        },
                        {
                          pattern: /^([1-9][0-9]+)$/,
                          message: '请输入大于等于10的数字'
                        },
                      ]}>
                        <Input type='number' style={{ width: '80px' }} placeholder='' />
                      </Form.Item>
                      <span style={{ margin: '0 0 0 6px' }}>字以内</span>
                      <span className={styles.nameTips}>（限制字数不得少于10字以内）</span>
                    </Row>
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </div>
        </div>
        <Row>
          <Col span={12}>
            <Button
              htmlType='button'
              onClick={() => {
                getDetail()
              }}
              style={{
                float: 'right',
                marginRight: '10px',
              }}
            >
              取消
            </Button>
          </Col>
          <Col span={12}>
            <Button
              loading={buttonLoading}
              type='primary'
              htmlType='submit'
              style={{
                float: 'left',
              }}
            >
              保存
            </Button>
          </Col>
        </Row>
      </Form>
    </Col >
  )
}
